import { ProductConstants } from '../_constants';

//-- save product by shopkeeper
export function saveProduct(state = {}, action) {
  switch (action.type) {
    case ProductConstants.PRODUCT_ADDED_REQUEST:
      return {
        addedProduct: false
      };

    case ProductConstants.PRODUCT_ADDED_SUCCESS:
      //console.log("ASC ", action.user);
      return { addedProduct:action.successAction};

    case ProductConstants.PRODUCT_ADDED_FAILURE:
      return {
        addedProduct: false,
      };

    default:
      return state
  }
}


//-- get all product for shopkeeper
export function getProduct(state = {}, action) {
  switch (action.type) {
    case ProductConstants.PRODUCT_GET_REQUEST:
      return {  Product: false };

    case ProductConstants.PRODUCT_GET_SUCCESS:      
      return { Product:action.successAction};

    case ProductConstants.PRODUCT_GET_FAILURE:
      return {  Product: false, };

    default:
      return state
  }
}


//-- get this product for shopkeeper
export function getSingleProduct(state = {}, action) {
  switch (action.type) {
    case ProductConstants.SINGLE_PRODUCT_GET_REQUEST:
      return {  Product: false };

    case ProductConstants.SINGLE_PRODUCT_GET_SUCCESS:      
      return { Product:action.successAction};

    case ProductConstants.SINGLE_PRODUCT_GET_FAILURE:
      return {  Product: false, };

    default:
      return state
  }
}


//-- UPDATE THE PRODUCT BY ID
export function updateSingleProduct(state = {}, action) {
  switch (action.type) {
    case ProductConstants.SINGLE_PRODUCT_UPDATE_REQUEST:
      return {  UpdatedProduct: false };

    case ProductConstants.SINGLE_PRODUCT_UPDATE_SUCCESS:      
      return { UpdatedProduct:action.successAction};

    case ProductConstants.SINGLE_PRODUCT_UPDATE_FAILURE:
      return {  UpdatedProduct: false, };

    default:
      return state
  }
}



//-- delete the product reducer
export function deleteProduct(state = {}, action) {
  switch (action.type) {
    case ProductConstants.DELETE_MY_PRODUCT_REQUEST:
      return {  deletedProduct: false };

    case ProductConstants.DELETE_MY_PRODUCT_SUCCESS:      
      return { deletedProduct:action.successAction};

    case ProductConstants.DELETE_MY_PRODUCT_FAILURE:
      return {  deletedProduct: false, };

    default:
      return state
  }
}


 
//-- get all attributes
export function getProductAttributes(state = {}, action) {
  switch (action.type) {
    case ProductConstants.GET_PRODUCT_ATTRIBUTE_REQUEST:
      return {  Attributes: false };

    case ProductConstants.GET_PRODUCT_ATTRIBUTE_SUCCESS:      
      return { Attributes:action.successAction};

    case ProductConstants.GET_PRODUCT_ATTRIBUTE_FAILURE:
      return {  Attributes: false, };

    default:
      return state
  }
}